import {CircularProgress, TextField, Autocomplete} from '@mui/material';

export interface OptionSelected {
	value?: string;
	label?: string;
	[key: string]: any;
}

export interface SelectProps {
  onChange?: (value: object) => void;
  value?: any;
  creatable: boolean;
  label?: string;
  groupBy?: any;
  placeholder?: string;
  getOptionLabel?: (option: OptionSelected) => string;
  disabled?: boolean;
  options: OptionSelected[];
  defaultValue?: any;
  PopperComponent?: any;
  multi?: boolean | any;
  className: string;
  loading?: boolean;
  onInputChange?: (event: React.ChangeEvent, newValue: string) => void;
	inputValue?: string;
  mandatory: boolean;
  error?: string;
  filterOptions?: (options: OptionSelected[], params: any) => OptionSelected[];
  id?: string;
  renderTags?: Function | any;
  getOptionDisabled?: Function;
  renderOption?: Function;
  renderInput?: Function;
  important?: string;
  helperText?: string;
  filterSelectedOptions?: boolean;
  isClearable?: boolean;
  getOptionSelected?: (option:any, value:any) => boolean;
  style?: any;
  excludedOptions?: any;
	fullWidth: boolean | undefined;
}

// @ts-ignore
export default class Select extends window.React.PureComponent<SelectProps, {}> {
	static defaultProps: SelectProps = {
		multi: false,
		creatable: false,
		options: [],
		className: '',
		mandatory: false,
		fullWidth: undefined
	};

  render() {
    const {
      label,
      loading,
      disabled,
      onChange,
      options,
      value,
      multi,
      placeholder,
      onInputChange,
      className,
      mandatory,
      getOptionLabel,
      error,
      filterOptions,
      creatable,
      id,
      renderTags,
      getOptionDisabled,
      renderOption,
      renderInput,
			inputValue,
      groupBy,
      important,
      helperText,
      PopperComponent,
      filterSelectedOptions,
      getOptionSelected,
      isClearable,
      style,
			fullWidth
    } = this.props;
    // @ts-ignore
		const finalValue = multi
			? Array.isArray(value) ? value : []
			: (value && !Array.isArray(value) ? value : null);

    return (
      <Autocomplete
        id={id}
        disabled={disabled}
        className={className}
        groupBy={groupBy}
        filterOptions={filterOptions}
        filterSelectedOptions={filterSelectedOptions ?? true}
        loading={loading}
        onInputChange={onInputChange}
        fullWidth={fullWidth}
        // open={true}
        // debug={true}
        multiple={multi}
        onChange={(_, value: any): void => onChange && onChange(value)}
        options={options}
				isOptionEqualToValue={
					getOptionSelected ??
					((option: OptionSelected, value: OptionSelected): boolean => option?.value === value?.value)
				}
        getOptionDisabled={getOptionDisabled}
				getOptionLabel={
					getOptionLabel
						? getOptionLabel
						: (option: any): string => {
							return option?.label || '';
						}
				}
				disableClearable={!isClearable}
        renderTags={renderTags}
        ChipProps={{
          size: 'small',
        }}
        style={style}
				slots={{
					popper: PopperComponent
				}}
        renderInput={renderInput ? renderInput : (params: any) => (
          <TextField
            {...params}
            label={label}
            //onChange={onInputChange ? onInputChange : params.onChange}
            placeholder={
              placeholder ||
              ((multi && finalValue?.length === 0) || (!multi && !finalValue)
                ? `${window.Alfresco.messages.global['button.select']}...`
                : '')
            }
            variant={'outlined'}
            required={mandatory}
            error={!!error}
            helperText={error || important || helperText}
						slotProps={{
							input: {
								...params.InputProps,
								endAdornment: (
									<React.Fragment>
										{loading ? <CircularProgress color="inherit" size={20} /> : null}
										{params.InputProps.endAdornment}
									</React.Fragment>
								),
							},
							inputLabel: {
								shrink: true,
							},
					}}
          />
        )}
        value={finalValue ?? null}
        freeSolo={creatable}
        renderOption={renderOption}
      />
    );
  }
}
